"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _antd = require("antd");

var _icons = require("@ant-design/icons");

var Icon = /*#__PURE__*/_react.default.createElement(_icons.LoadingOutlined, {
  style: {
    fontSize: 35
  },
  spin: true
});

var Loading = function Loading(props) {
  var align = props.align,
      cover = props.cover;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "loading text-".concat(align, " cover-").concat(cover)
  }, /*#__PURE__*/_react.default.createElement(_antd.Spin, {
    indicator: Icon
  }));
};

Loading.defaultProps = {
  align: 'center',
  cover: 'inline'
};
var _default = Loading;
exports.default = _default;